import React from 'react';
import { Box } from '@mui/material';
import { isEmpty } from 'lodash';
import {
  Container,
  CustomStyledButton,
  StyledLogo,
  LogoContainer,
  Wrapper,
  TopRightVector,
  BottomLeftVector,
  PositioningWrapper
} from './styled';
import { Loader } from '../common/styled/loader';
import LoginVector1 from '../../assets/images/login-vector1.png';
import LoginVector2 from '../../assets/images/login-vector2.png';
import { AdminAuthContainerProps } from '../HomePage/types';
import AdminAuthSections from './AdminAuthSections';
import DisclaimerFooter from './DisclaimerFooter';

const AdminAuthContainer = ({
  logoSrc = '',
  sections,
  children,
  buttonText,
  footerText = '',
  footerLinks = [],
  isLoading = false,
  isButtonDisabled = false,
  onSubmit
}: AdminAuthContainerProps) => {
  return (
    <Wrapper>
      <PositioningWrapper>
        <TopRightVector src={String(LoginVector1)} />
        <BottomLeftVector src={String(LoginVector2)} />
        <Container>
          <Box margin={5}>
            {logoSrc && (
              <LogoContainer>
                <StyledLogo src={logoSrc} alt='ether' />
              </LogoContainer>
            )}
            {sections.map((section, index) => (
              <AdminAuthSections key={index} {...section} />
            ))}
            {children}
            {isEmpty(buttonText) && isLoading && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '30px'
                }}
              >
                <Loader size='2rem' />{' '}
              </div>
            )}
            {footerText && (
              <DisclaimerFooter
                footerText={footerText}
                footerLinks={footerLinks}
              />
            )}
            {!isEmpty(buttonText) && (
              <CustomStyledButton
                variant='contained'
                fullWidth
                disabled={isButtonDisabled}
                onClick={onSubmit}
              >
                {isLoading ? <Loader size='1.5rem' /> : buttonText}
              </CustomStyledButton>
            )}
          </Box>
        </Container>
      </PositioningWrapper>
    </Wrapper>
  );
};

export default AdminAuthContainer;
